const url={
	devUrl:'https://s.vormor.cn',//'https://b.vormor.cn',//'http://192.168.2.114:8200'
	//proUrl:'http://192.168.2.114:8200',
	proUrl:'https://s.vormor.cn',
}
export const baseUrl =process.env.NODE_ENV === 'development'? url.devUrl: url.proUrl;